module.exports = __webpack_public_path__ + "img/KYC-vida.96c5b1f0.png";